import type {RouteLocationNormalizedLoaded} from 'vue-router'

export async function useCarRentRuntimeData(route: RouteLocationNormalizedLoaded) {
    const searchRequest = route.query
    const {pickUpCityId, dropOffCityId} = searchRequest
    const promises = []
    if (pickUpCityId && pickUpCityId !== carsRentRuntimeStore.pickUpPoint.id) {
        promises.push(carsRentRuntimeStore.loadPickUpPoint(pickUpCityId))
    }
    if (dropOffCityId && dropOffCityId !== carsRentRuntimeStore.dropOffPoint.id) {
        promises.push(carsRentRuntimeStore.loadDropOffPoint(dropOffCityId))
    }
    await Promise.all(promises)
}
